import { SWITCHES } from '@/config'
import { isJobDetailPage, isJobPreviewPage } from '@/page/store/selectors'
import { getResultsSearchType } from '@/results/store/selectors'
import { isJob } from '@/search/constants'

import { isLandingPageVisible } from '../../landingPage/store/selectors'

import defaultState, { DEFAULT_SEARCH_JOBMAIL_STATE } from './defaultState'

const getState = state => state.jobmail || defaultState

export const getErrors = state => getState(state).errors
export const getSearchJobmailOpen = state => (getState(state).searchJobmailState || DEFAULT_SEARCH_JOBMAIL_STATE).open
export const getOverlay = state => (getState(state).searchJobmailState || DEFAULT_SEARCH_JOBMAIL_STATE).overlay

export const getShowSearchJobmail = (state) => {
  const jobmailState = getState(state)
  if (!SWITCHES.enableJobmail || !jobmailState.searchJobmailState.visible) {
    return false
  }
  return isJob(getResultsSearchType(state)) && !isJobDetailPage(state) && !isJobPreviewPage(state) && !isLandingPageVisible(state)
}

export const getSubmitting = state => getState(state).submitting
export const getSlideInEnabled = state => getState(state).slideInEnabled
export const getSlideInPaused = state => getState(state).slideInPaused
export const getModalOpen = state => getState(state).modalOpen
export const getOpenSearchJobmailDueToScroll = (state) => (getState(state).searchJobmailState || DEFAULT_SEARCH_JOBMAIL_STATE).dueToScroll
